module.exports = __webpack_public_path__ + "static/media/cnn.com_specials_politics_2016-primaries-results_plot.cda1d161.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_specials_politics_2016-primaries-results_plot.png
// module id = 384
// module chunks = 0